import { Card, Space, Avatar, Typography } from 'antd';

const { Text } = Typography;
/**
 * Tarjeta para mostrar los encabezados de las ventas online
 * @param {*} label nombre de la etiqueta que saldra en la Card
 * @param {*} icon icono que se mostrara en la card
 * @param {*} color que se mostrara en la card
 * @returns 
 */
const StatusCardHeader = ({ label, icon, color }) => {
  return (
    <Card
      size="small"
      style={{
        textAlign: "center",
        borderRadius: "12px",
        borderTop: `3px solid ${color}`,
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        marginBottom: "6px",
      }}
    >
      <Space align="center" size={8}>
        <Avatar
          size={28}
          icon={icon}
          style={{
            backgroundColor: `${color}15`,
            color: color,
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
        <Text
          strong
          style={{
            fontSize: "11px",
            color: "#595959",
            textTransform: "uppercase",
            letterSpacing: "0.5px"
          }}
        >
          {label}
        </Text>
      </Space>
    </Card>
  );
};

export default StatusCardHeader;